<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-rrhh-fractions-discount"
      :title="$t('DISCOUNT SCHEDULE')"
      modal-class="modal-primary"
      hide-footer
      @hidden="$emit('hideModal')"
      size="lg"
      scrollable
    >
      <div class="mb-2 mt-1">
        <b-row>
          <!-- <b-col sm="6">
            <b-input-group class="mb-1">
              <template #prepend>
                <b-input-group-text class="prepend__width">
                  <strong>CODE</strong>
                </b-input-group-text>
              </template>
              <b-form-input :value="dataModal.code" disabled />
            </b-input-group>
          </b-col> -->
          <b-col sm="12">
            <b-input-group class="mb-1">
              <template #prepend>
                <b-input-group-text class="prepend__width">
                  <strong>NAME</strong>
                </b-input-group-text>
              </template>
              <b-form-input :value="modalData.full_name" disabled />
            </b-input-group>
          </b-col>
        </b-row>
      </div>
      <div class="table-responsive">
        <b-table
          small
          sticky-header="50vh"
          class="position-relative"
          table-class="text-nowrap"
          :items="items"
          :fields="filteredFields"
        >
          <template #cell(discount_date)="data">
            <span style="opacity: 0.7">
              {{ data.value | myGlobal }}
            </span>
          </template>
          <template #cell(tipo_descuento)="data">
            <span> {{ data.value | capitalize }} </span>
          </template>
          <template #cell(amount)="data">
            <span> S/.{{ data.value | currency }} </span>
          </template>
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="`light-${
                data.item.status == 'Discounted' ? 'success' : 'warning'
              }`"
            >
              <span> {{ $t(data.value) }} </span>
            </b-badge>
          </template>
          <template #cell(fecha_descontado)="data">
            <span v-if="data.item.status === 'Discounted' && data.value" class="text-success">
              {{ data.value | myGlobal }}
            </span>
            <span v-else class="text-muted">—</span>
          </template>
          <template #cell(description)="data">
            <span> {{ data.value | capitalize }} </span>
          </template>
          <template #cell(observation)="data">
            <span> {{ data.value }} </span>
          </template>
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import modalMixin from "@/mixins/modal";

/* Service */
import DiscountService from "@/views/commons/discounts/services/discounts.service.js";
import AdelantoService from "@/views/rrhh/views/payroll/components/adelanto-sueldo/services/adelanto.sueldo.service.js";

export default {
  mixins: [modalMixin],
  props: {
    modalData: {
      type: Object,
      require: true,
    },
    origin: {
      type: String,
      default: "descuento",
    },
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: "discount_date",
          label: this.$t("Discount Date"),
          visible: true,
        },
        {
          key: "tipo_descuento",
          label: this.$t("Discount Type"),
          visible: true,
        },
        {
          // [1]
          key: "amount",
          label: this.$t("Amount"),
          visible: true,
        },
        {
          // [1]
          key: "status",
          label: this.$t("Status"),
          visible: true,
        },
        {
          key: "fecha_descontado",
          label: "Fecha Descontado",
          visible: true,
        },
      ],
    };
  },
  computed: {
    filteredFields() {
      if (this.origin === "adelanto") {
        return this.fields.filter(
          (field) => field.key !== "status" && field.key !== "fecha_descontado"
        );
      }
      return this.fields;
    },
  },
  mounted() {
    this.toggleModal("modal-rrhh-fractions-discount");
  },
  async created() {
    await this.getDiscountFractionsById();
  },
  methods: {
    async getDiscountFractionsById() {
      try {
        this.addPreloader();

        let data;
        if (this.origin === "adelanto") {
          const params = {
            id_adelanto: this.modalData.id_adelanto,
          };
          ({ data } = await AdelantoService.getDiscountFractionsById(params));
        } else {
          const params = {
            discount_id: this.modalData.discount_id,
          };
          ({ data } = await DiscountService.getDiscountFractionsById(params));
        }

        this.items = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style scoped>
.py-1s {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>